/* TRĒ House promo landing page — assets/tre-promo.js */
(function () {
  var root = document.getElementById('tre-promo');
  if (!root) return;

  /* ── Scroll progress bar ─────────────────────────────── */
  var bar = document.getElementById('tp-progress');
  function progress() {
    if (!bar) return;
    var de = document.scrollingElement || document.documentElement;
    var max = de.scrollHeight - de.clientHeight;
    bar.style.width = (max > 0 ? (de.scrollTop / max) * 100 : 0) + '%';
  }
  document.addEventListener('scroll', progress, { passive: true });
  window.addEventListener('resize', progress, { passive: true });
  progress();

  /* ── Header condense ─────────────────────────────────── */
  var header = document.getElementById('tp-header');
  var sentinel = document.getElementById('tp-sentinel');
  if (header && sentinel && window.IntersectionObserver) {
    new IntersectionObserver(function (e) {
      header.setAttribute('data-scrolled', e[0].isIntersecting ? 'false' : 'true');
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ── Mobile menu ─────────────────────────────────────── */
  var menu = document.getElementById('tp-mobile-menu');
  var menuBtn = document.getElementById('tp-menu-btn');
  function setMenu(open) {
    if (!menu || !menuBtn) return;
    menu.setAttribute('data-open', open ? 'true' : 'false');
    menu.style.transform = open ? 'translateY(0)' : 'translateY(-102%)';
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (menuBtn) menuBtn.addEventListener('click', function () {
    setMenu(menu.getAttribute('data-open') !== 'true');
  });
  if (menu) menu.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') setMenu(false);
  });

  /* ── Copy discount code ──────────────────────────────── */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    var code = root.getAttribute('data-promo-code') || '';
    if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
    var label = btn.querySelector('[data-copy-label]');
    if (label) {
      label.textContent = 'copied';
      setTimeout(function () { label.textContent = 'tap to copy'; }, 1800);
    }
  });

  /* ── AJAX add to cart (falls back to a normal POST) ──── */
  var count = document.getElementById('tp-cart-count');
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-tp-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent.trim() : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (count) count.textContent = cart.item_count;
        if (btn) btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.textContent = original || 'Add to Cart'; }
        }, 1400);
      });
  });
})();
